module.exports = __webpack_public_path__ + "static/img/train-floor.cfbde769.png";